import styled from 'styled-components';
import DefaultModal from 'components/Modals/Modal';
import { Body, H3 } from 'components/Typography';
import { FiCheckCircle } from 'react-icons/fi';
import DefaultButton from 'components/Buttons/Button';
import addAlpha from 'utils/addAlpha';

export const Modal = styled(DefaultModal)`
  .modal-ui {
    width: 45.6875rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

// TODO: TFR-49 look similar to other content in modals. Could be easier to make helper for modals
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0rem;
  width: 100%;
  min-height: 9.625rem;
`;

// TODO: TFR-45:IconWrapper make unique name or do not export
export const IconWrapper = styled.div`
  width: 5rem;
  height: 5rem;
  border: 0.0625rem solid ${({ theme }) => theme.colors.gray2};
  border-radius: 50%;
  font-size: 1.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// TODO: TFR-44 move to icons group
export const CheckIcon = styled(FiCheckCircle)`
  color: ${({ theme }) => theme.colors.greenDark};
`;

// TODO: TFR-45:Title make unique name or do not export
export const Title = styled(H3)`
  color: ${({ theme }) => theme.colors.navyGreen};
  margin-top: 1rem;
  text-align: center;
`;

// TODO: TFR-45:Text make unique name or do not export
export const Text = styled(Body)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
  margin-top: 0.5rem;
  margin-bottom: 2.25rem;
  text-align: center;
`;

// TODO: TFR-44 move to typography group
export const SuccessText = styled(Text)`
  width: 27rem;
  margin-top: 1rem;
`;

// TODO: TFR-45:Button make unique name or do not export
export const Button = styled(DefaultButton)`
  width: 100%;
`;
